import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';

import { Router, RouterOutlet } from '@angular/router';
import { Scroll2tbModule } from 'axis-components/scroll2tb';

import { AlertModule } from 'axis-components';
import { Logger } from './_core/logger.service';
import { ConfigService } from './_core/service/config.service';
import { LocationService } from './_core/service/location.service';
import { NotificationService } from './_services/notification/notification.service';
import { AnalyticsDirective } from './_shared/analytics/analytics.directive';
import { AnalyticsService } from './_shared/analytics/analytics.service';
import { AppNavbarComponent } from './app-navbar.component';
import { FooterComponent } from './footer.component';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    AppNavbarComponent,
    FooterComponent,
    RouterOutlet,
    Scroll2tbModule,
    CommonModule,
    AlertModule,
    AnalyticsDirective,
  ],
})
export class AppComponent {
  // title = 'ABC Insured - Business Auto';
  showNavbar = true;
  request;
  analyticsUrl: string;

  adobeDataLayer;

  notificationMessage: string = 'See copydeck for text.';
  notificationType = 'error';
  notificationTitle: string = '';
  alertTimeOut = 5000;
  alertAutoClose = true;
  alertFadeOut = true;

  @ViewChild('alertComponent') alertNotificationComponent;

  constructor(
    public router: Router,
    private configService: ConfigService,
    private locationService: LocationService,
    private notificationService: NotificationService,
  ) {
    this.analyticsUrl = this.configService.getConfig().analyticsUrl;
    const params = new URLSearchParams(this.locationService.search);
    const requestId = params.get('key');

    if (!requestId) {
      const pathname = this.locationService.pathname;
      const excludePaths = ['invalid', 'completed', 'maintenance'];
      if (excludePaths.some((path) => pathname.includes(path))) {
        return;
      }
      Logger.log('No requestId found in URL, navigating to 404');
      this.router.navigate(['/404']);
      return;
    }

    this.notificationService.notification$.subscribe((data) => {
      this.notificationType = data.type;
      this.notificationTitle = data.title;
      this.notificationMessage = data.message;

      this.alertAutoClose = this.notificationType === 'error';
      this.alertFadeOut = this.alertAutoClose;
      this.alertTimeOut = this.alertAutoClose ? 5000 : 0;

      if (this.alertNotificationComponent) {
        this.alertNotificationComponent.autoClose = this.alertAutoClose;
        this.alertNotificationComponent.datafadeout = this.alertFadeOut;
        this.alertNotificationComponent.timeOut = this.alertTimeOut;
      }

      this.alertNotificationComponent?.openAlert();
    });
  }
}
